import React, { useEffect, useState } from "react";

import { CloseGreyIcon, DangerRoundRedIcon } from "../../../assets/icons";
import PaymentBankAccountTab from "./PaymentBankAccountTab";
import PaymantCryptoTab from "./PaymentCryptoTab";
import { PlanInputSelectDTO } from "../../../models/plan/plan.response";
import Loader from "../../shared/Loader";
import { useNotification } from "../../toster-notification/NotificationContext";
import { planService } from "../../../services/planService";
import { planSubscriptionService } from "../../../services/planSubscriptionService";
import { useParams } from "react-router-dom";

interface PaymantInfoViewProps {
    onClose: () => void;
}

const PaymantInfoView: React.FC<PaymantInfoViewProps> = ({ onClose }) => {

    const [plans, setPlans] = React.useState<PlanInputSelectDTO[]>([]);
    const [selectedPlanId, setSelectedPlanId] = React.useState<string>("");
    const [selectedTab, setSelectedTab] = React.useState<"bank" | "crypto">("bank");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();

    useEffect(() => {
        fetchPlans();
    }, []);


    const fetchPlans = async () => {
        setLoading(true);
        try {
            const response = await planService.getInputSelect();
            if (response.success && response.data) {
                setPlans(response.data);
            } else {
                notify("error", "Greška prilikom učitavanja planova");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja planova");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section payment-options">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Plaćanje članarine</div>
                                <div className="description-text">
                                    Izaberite način plaćanja i pratite instrukcije<br />
                                </div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" onClick={onClose} />
                            </div>
                        </div>
                        <div className="modal-box-div">
                            <div className="modal-box-header-div">
                                <div className="modal-box-header-title">Paket</div>
                                <div className="description-text">
                                    Izaberite paket za Vaš lokal<br />
                                </div>
                            </div>
                            <select className="form-select auto-width w-select"
                                value={selectedPlanId}
                                onChange={(e) => setSelectedPlanId(e.target.value)}
                            >
                                <option value="">Izaberite paket</option>
                                {plans.map(plan => (
                                    <option key={plan.id} value={plan.id}>{plan.name} - {plan.price} RSD</option>
                                ))}
                            </select>
                        </div>

                        <div className="modal-box-div">
                            <div className="modal-payment-info-row">
                                <div className="modal-payment-info-row-left-div">
                                    <div className="description-text">Lokacija</div>
                                    <div className="bold-1rem">Restoran Zlatna Lađa</div>
                                </div>
                                <div className="modal-payment-info-row-right-div">
                                    <div className="description-text">Plan</div>
                                    <div className="small-box-div grey-bg">
                                        <div>{selectedPlanId ? plans.find(p => p.id === selectedPlanId)?.name : "Izaberite paket"}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-box-hr"></div>
                            <div className="modal-payment-info-row">
                                <div className="modal-payment-info-row-left-div">
                                    <div className="description-text">Iznos za uplatu:</div>
                                </div>
                                <div className="modal-payment-info-row-right-div">
                                    <div className="_1-25rem-bold">{selectedPlanId ? plans.find(p => p.id === selectedPlanId)?.price : "0"} RSD</div>
                                    <div className="description-text">
                                        <div>
                                            (~ {(selectedPlanId && plans.find(p => p.id === selectedPlanId)?.price) ? (plans.find(p => p.id === selectedPlanId)?.price! * 0.011).toFixed(2) : "0"} USDT)<br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-nav-div">
                            <div className={`modal-nav-button ${selectedTab === "bank" ? "selected" : ""}`} onClick={() => setSelectedTab("bank")}>
                                <div>Žiro račun</div>
                            </div>
                            <div className={`modal-nav-button ${selectedTab === "crypto" ? "selected" : ""}`} onClick={() => setSelectedTab("crypto")}>
                                <div>Kripto (USDT)</div>
                            </div>
                        </div>

                        {selectedTab === "bank" ? (
                            <PaymentBankAccountTab
                                plan={plans.find(p => p.id === selectedPlanId)}
                            />
                        ) : (
                            <PaymantCryptoTab
                                plan={plans.find(p => p.id === selectedPlanId)}
                            />
                        )}

                    </div>
                </div>
            </div>
        </section>

    );
};

export default PaymantInfoView;